import React from 'react';
import styled from 'styled-components';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Seaotters from '../../components/Seaotters/Seaotters';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardSeaotters extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Seaotters/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Target}
   metricsm="Threatened"
   diagnosis="As top predators, sea otters are critical to maintaining the balance of nearshore ecosystems, such as kelp forests, embayments and estuaries. Pollution, fishing, and temperature rise are threatening their habitat."
   prediction="With fewer Sea Otters, the population of urchins could multiply. Urchins could potentially consume an entire Kelp forest if left unchecked (NRDC)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardSeaotters;
